import { P2GBox, P2GButton, P2GGrid, P2GText, useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { TranslationNamespaces } from '~/lib/constants';

export default function EmptyBasketMessage() {
  const { isAuthenticated, signinRedirect } = useAuth();
  const { t } = useTranslation([TranslationNamespaces.CHECKOUT]);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isXs = useP2GMediaQueryOnly('xs');

  const isUserFromEmailClick = useMemo(() => {
    return searchParams.get('utm_medium') === 'email';
  }, [searchParams]);

  const onReload = useCallback(() => navigate({ pathname: `../quote` }, { relative: 'path' }), [navigate]);

  return (
    <>
      {isAuthenticated || !isUserFromEmailClick ? (
        <P2GBox pt={10} pb={10} textAlign="center">
          <P2GGrid container direction="column" spacing={3}>
            <P2GGrid item>
              <P2GText dataTestId="empty-basket" variant="h2">
                {t('BASKET_EMPTY_TITLE', { defaultValue: 'Your basket is empty' })}
              </P2GText>
            </P2GGrid>
            <P2GGrid item>
              <P2GText variant="body1">
                {t('BASKET_EMPTY_MESSAGE', {
                  defaultValue: `…but don’t worry! You can get a quote using the button below.`
                })}
              </P2GText>
            </P2GGrid>
            <P2GGrid item>
              <P2GButton onClick={onReload} fullWidth={isXs} size="large" variant="primary">
                {t('BASKET_GET_QUOTE_BUTTON', { defaultValue: 'Get a Quote' })}
              </P2GButton>
            </P2GGrid>
          </P2GGrid>
        </P2GBox>
      ) : (
        <P2GBox pt={10} pb={10} textAlign="center">
          <P2GGrid container direction="column" spacing={3}>
            <P2GGrid item>
              <P2GText dataTestId="empty-basket" variant="h2">
                {t('BASKET_EMPTY_TITLE_EMAIL', { defaultValue: 'You’re signed out' })}
              </P2GText>
            </P2GGrid>
            <P2GGrid item>
              <P2GText variant="body1">
                {t('BASKET_EMPTY_MESSAGE_EMAIL', {
                  defaultValue: `Sign in to access your account and check your basket`
                })}
              </P2GText>
            </P2GGrid>
            <P2GGrid item>
              <P2GButton
                onClick={() => signinRedirect({ state: window.location.href })}
                fullWidth={isXs}
                size="large"
                variant="primary"
              >
                {t('BASKET_GET_QUOTE_BUTTON_EMAIL', { defaultValue: 'Sign In' })}
              </P2GButton>
            </P2GGrid>
          </P2GGrid>
        </P2GBox>
      )}
    </>
  );
}
